<template>
  <div style="padding: 1vw">
    <div style="display: flex; justify-content: space-between; align-items: flex-end; padding: 0 1vw">
      <div class="pageTitle">
        <h3 class="fw-bold" style="color: #000; font-size: 1.8rem">
          앱 버전 관리
        </h3>
        <span class="pageDesc">
          앱의 버전을 등록하고 관리할 수 있습니다.
        </span>
      </div>
      <div style="display: flex; align-items: center;">
        <button
          class="btn btn-primary"
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#versionInfoWModal"
        >
          등록하기
        </button>
      </div>
    </div>
    <div class="filterWrap" style="">
      <div class="searchdropbox">
        <select v-model="searchAppType"
          @change="getVersionsList(false)"
          >
          <option value="" selected>앱 유형 선택</option>
          <option v-for="(item, key) in appTypes" :value="key" :key="key">{{ `${item}` }}</option>
        </select>
        <select v-model="searchDevice" 
        @change="getVersionsList(false)"
        >
          <option value="" selected>기기 종류 선택</option>
          <option v-for="(item, key)  in devices" :value="key" :key="key">{{ `${item}` }}</option>
        </select>   
        <button
          @click="initFilter()"
        >
          옵션 초기화
        </button>
      </div>
      <div class="searchinputbox">
        <select class="search-select" v-model="rowsPerPage" @change="handleRowsPerPage">
          <option :value="10">10개씩 보기</option>
          <option :value="20">20개씩 보기</option>
          <option :value="50">50개씩 보기</option>
        </select>
      </div>
    </div>

    <div class="container-wrapper">
      <a-table 
        class="ant-table-striped"
        size="small"
        v-if="responseData"
        :columns="columns"
        :data-source="responseData"
        :pagination="false"
        @resizeColumn="handleResizeColumn"
      >
        <template #emptyText>
          <div class="noResult">검색 결과가 없습니다.</div>
        </template>
      </a-table>
      <pagination 
        :page-info="paginationData"
        page-name="CertificateList"
        @change-page="paginationHandler"
      />
    </div>
    <!-- 초기화 모달 -->
    <div
    class="modal fade"
    id="resetyesno"
    tabindex="-1"
    aria-labelledby="resetModalLabel"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-dialog-centered"
      style="justify-content: center !important"
    >
      <div
        class="modal-content"
        style="width: 70% !important; padding-top: 0.5vw"
      >
        <div class="modal-body" style="display: flex; flex-direction: column">
          <div style="text-align: center; padding-top: 1rem">
            <h4>비밀번호 초기화</h4>
            <h6>임시 비밀번호는 사용자 아이디와 동일합니다.</h6>
            <h6>초기화하시겠습니까?</h6>
          </div>
          <div style="display: flex; justify-content: center; margin-top: 2rem">
            <button
              style="margin-right: 1vw;"
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
            취소
            </button>
            <button
              type="button"
              class="btn btn-warning"
              data-bs-dismiss="modal"
              @click="resetPassword()"
            >
            초기화
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- 삭제 모달 -->
  <div
  class="modal fade"
  id="deleteyesno"
  tabindex="-1"
  aria-labelledby="resetModalLabel"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-centered"
    style="justify-content: center !important"
  >
    <div
      class="modal-content"
      style="width: 70% !important; padding-top: 0.5vw"
    >
      <div class="modal-body" style="display: flex; flex-direction: column">
        <div style="text-align: center; padding-top: 1rem">
          <h4>앱 버전 삭제</h4>
          <h6>해당 버전을 삭제하시겠습니까?</h6>
        </div>
        <div style="display: flex; justify-content: center; margin-top: 2rem">
          <button
            style="margin-right: 1vw;"
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
          취소
          </button>
          <button
            type="button"
            class="btn btn-warning"
            @click="deleteVersion()"
          >
          삭제
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
  </div>
  <VersionInfoW/>
  <VersionInfoM :data="versionDetailData"/>
  <VersionInfoR :data="versionDetailData"/>

</template>
<script>
import { convertDate, openDialog, convertDateTime,  } from "@/utils/utils";
import { devices, appTypes } from "@/enums/common.enums";
import VersionInfoW from "@/views/components/AppVersionInfoW.vue";
import VersionInfoM from "@/views/components/AppVersionInfoM.vue";
import VersionInfoR from "@/views/components/AppVersionInfoR.vue";
import Pagination from "@/views/components/Pagination.vue";



export default {
  name: "versionManage",
  components: {
    VersionInfoW,
    VersionInfoM,
    VersionInfoR,
    Pagination,
  },
  data() {
    return {
      convertDateTime,
      // 목록 받아오는 변수
      responseData: [], 

      selectedVersion: "", // 선택한 버전의 고유 id
      versionDetailData: {}, // 상세보기, 수정 등에 사용하기 위한 데이터를 넣는 변수

      devices: devices, // 기기별로
      appTypes: appTypes, // 환자앱인지 병원앱인지
      searchAppType: "", // 검색어조건
      searchDevice: "", // 검색어조건



      // 페이지네이션 관련 변수
      listSize: 0,
      rowsPerPage: 10, // Default, can be changed by the user
      paginationData: {
        currentPage: 1, 
        totalPages: 0,
      },
      columns: [
        {
          key: 'appType',
          title: '앱 유형',
          dataIndex: 'appType',
          align: 'center',
          
          customRender: ({ record }) => this.convertAppType(record.appType)
        },
        {
          key: 'device',
          title: '디바이스',
          dataIndex: 'device',
          align: 'center',
          
          customRender: ({ record }) => this.convertDevice(record.device)
        },
        { key: 'version', title: '버전', dataIndex: 'version', align: 'center', },
        {
          key: 'forceUpdateYn',
          title: '강제 업데이트 유무',
          dataIndex: 'forceUpdateYn',
          align: 'center',
          
          customRender: ({ record }) => record.forceUpdateYn === 'Y' ? '예' : '아니오'
        },
        {
          key: 'liveVersionYn',
          title: '라이브 버전 유무',
          dataIndex: 'liveVersionYn',
          align: 'center',
          
          customRender: ({ record }) => record.liveVersionYn === 'Y' ? '예' : '아니오'
        },
        {
          key: 'createAt',
          title: '등록 일시',
          dataIndex: 'createAt',
          align: 'center',
          
          customRender: ({ record }) => this.convertDateTime(record.createAt)
        },
      {
          key: 'manage',
          title: '관리',
          dataIndex: 'manage',
          align: 'center',
          customRender: ({ record }) => (
            <div
              style="display: flex; gap: 8px; justify-content: center;"
            >
              <div
                data-bs-toggle="modal"
                data-bs-target="#versionInfoRModal"
                class="certi-custom-btn"
                onClick={() => this.getVersionDetail(record._id)}
              >
                상세보기
              </div>
              <div
                data-bs-toggle="modal"
                data-bs-target="#versionInfoMModal"
                class="certi-custom-btn"
                onClick={() => this.getVersionDetail(record._id)}
              >
                수정
              </div>
              <div
                data-bs-toggle="modal"
                data-bs-target="#deleteyesno"
                class="certi-custom-btn"
                onClick={() => this.selectVersion(record._id)}
              >
                삭제
              </div>
            </div>
          )
        }
      ],
    };
  },
  
  async mounted() {
    const obj = {};
    obj.page = this.paginationData.currentPage;
    this.paginationHandler(obj);
    const a = document.getElementById('versionInfoWModal')
  },
  methods: {
    async paginationHandler(childPassParam) {
      this.paginationData.currentPage = childPassParam.page;
      await this.getVersionsList();

    },

    handleResizeColumn(w, col) {
      col.width = w;
    },
    // 주요 API
    // 버전 목록 가져오기
    async getVersionsList() {
      const params = {};
      params.page = this.paginationData.currentPage;
      params.limit = this.rowsPerPage;
      if(this.searchDevice) params.device = this.searchDevice;
      if(this.searchAppType) params.appType = this.searchAppType;
      try {
        const response = await this.$apiInstance.get(`/appversions`, {params});
        if(response.status === 200 || response.status === 201) {
          this.responseData = response.data.docs;
          this.listSize = response.data.totalDocs;
          this.paginationData.totalPages = response.data.totalPages;
          for (let i = 0; i < this.responseData.length; i++) {
            this.responseData[i].index =
              this.listSize - i - (this.paginationData.currentPage - 1) * this.rowsPerPage;
          }
        }
      } catch(error) {
        console.log(error);
      }
    },
    async handleRowsPerPage() {
      this.paginationData.currentPage = 1;
      await this.getVersionsList();
    },
    // 버전 삭제
    async deleteVersion() {
      try {
        const response = await this.$apiInstance.delete(
          `/appversions/${this.selectedVersion}`,
        )
        if(response.status === 200 || response.status === 201) {
          await openDialog("해당 앱 버전 정보가 삭제되었습니다.","success", "확인")
          .then(() => {
            location.reload();
          });
        } else {
          await openDialog("앱 버전 정보 삭제에 실패하였습니다.", "error", "확인");
        }
      } catch(error) {
        console.log(error);
        await openDialog("앱 버전 정보 삭제에 실패하였습니다.", "error", "확인");
      }
    },

     // 버전 정보 상세
     async getVersionDetail(id) {
      try {
        const response = await this.$apiInstance.get(
        `/appversions/${id}`,
        )
        if(response.status === 200 || response.status === 201) {
          this.versionDetailData = response.data;
          this.versionDetailData.versionId = id;
        }
      } catch(error) {
        console.log(error);
      }
    },

    // 기타 ManuManage용 utils

    // 엔터 눌렀을 때
    async enter() {
      if(this.searchFilter === "") {
        await openDialog("검색 필터를 선택해 주세요.","error", "확인");
      } else {
        this.paginationData.currentPage = 1;
        this.getVersionsList();
      }
    },

    // 필터 초기화
    initFilter() {
      this.searchDevice = "";
      this.searchAppType = "";
      this.paginationData.currentPage = 1;
      this.getVersionsList();
    },

    // 날짜, 시간 포맷에 맞추기
    convertDate,

    // 보기, 수정, 삭제 시 선택
    selectVersion(versionId) {
      this.selectedVersion = versionId;
    },

    // 앱 타입 변환
    convertAppType(input) {
      if(input === "CUSTOMER") {
        return appTypes.CUSTOMER;
      } else if(input === "HOSPITAL") {
        return appTypes.HOSPITAL;
      } else if(input === "MANUFACTURER") {
        return appTypes.MANUFACTURER;
      } else {
        return "-";
      }
    },

    // 기기 종류 변환
    convertDevice(input) {
      if(input === "IOS") {
        return devices.IOS;
      } else if(input === "AOS") {
        return devices.AOS;
      } else {
        return devices.ETC;
      }
    },
  },
};
</script>
